// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export const appEnvironment = () =>
  import.meta.env.VITE_ENV_APP_HOSTING_ENVIRONMENT;
